/**
 * Initializes calendar filtering and date selection behavior.
 */
function init() {
  initFilters();
  initDatePicker();
}

// =============================================================================================
// FILTERS
// =============================================================================================

/**
 * Restores filter selections from URL parameters on page load, and navigates to a filtered
 * URL when any filter selection changes.
 */
function initFilters() {

  if (document.getElementById('calFilters')) {
    const urlParams = new URLSearchParams(window.location.search);
    ['genre', 'cat', 'partner', 'venue'].forEach(param => {
      const value = urlParams.get(param) || '';
      if (value) {
        const el = document.querySelector(`#calFilters select[name="${param}"]`);
        if (el) {
          el.value = value;
          el.classList.add('selected');
        }
      }
    });
  }

  document.querySelectorAll('#calFilters select, #calFilters input').forEach(el => {
    el.addEventListener('change', () => {
      el.classList.toggle('selected', !!el.value);
      const params = new URLSearchParams(new FormData(document.getElementById('calFilters')));
      for (const [key, value] of [...params.entries()]) {
        if (!value) params.delete(key);
      }
      window.location.href = `${window.location.pathname}${params.size? '?' + params : ''}`;
    });
  });

}

// =============================================================================================
// DATE PICKER
// =============================================================================================

/**
 * Handles calendar date cell selection, updating the events panel header and fetching events
 * for the selected date via the appropriate API endpoint.
 */
function initDatePicker() {
  document.querySelectorAll('#calPicker td.calendar-pad').forEach(td => {
    td.addEventListener('click', () => {

      document.querySelectorAll('#calPicker td').forEach(t => t.classList.remove('active'));
      td.classList.add('active');

      const site = td.dataset.site;
      const date = td.dataset.date;
      const dateLabel = td.dataset.dateLabel;
      const eventCount = Number(td.dataset.eventCount);

      const hashes = window.location.search.slice(1);

      const url = hashes
        ? `/api/events-filtered.json?site=${site}&date=${date}&${hashes}`
        : `/api/events-date.json?site=${site}&date=${date}`;

      document.querySelector('#calEvents #calEventsDate').textContent = dateLabel;
      document.querySelector('#calEvents #calEventsCount').textContent = `${eventCount} event${eventCount !== 1? 's' : ''}`;
      document.getElementById('calEventsListings').classList.add('loading');

      fetch(url)
        .then(r => r.json())
        .then(data => {
          const events = data.data;
          const allDay = events.filter(event => !!event.allDay);
          const notAllDay = events.filter(event => !event.allDay);

          allDay.sort((x, y) => x.title.localeCompare(y.title));

          const calList = document.getElementById('calList');
          calList.innerHTML = '';

          notAllDay.forEach(event => {
            if (date === event.startDate) {
              appendEvent(calList, event, event.startTime);
            }
          });

          allDay.forEach(event => appendEvent(calList, event, 'All Day'));

          document.getElementById('calEventsListings').classList.remove('loading');
        });

    });
  });
}

// =============================================================================================
// EVENT RENDERING
// =============================================================================================

/**
 * Appends an event item to the calendar list if the event is enabled.
 *
 * @param {HTMLElement} list The list container to append to.
 * @param {Object} event The event data object.
 * @param {string} time Display time string (e.g. "7:00pm" or "All Day").
 */
function appendEvent(list, event, time) {
  if (!event.enabled) return;
  const venue = event.venue.length? event.venue[0].title : '';
  const isFree = event.category.some(e => e.id === 63);
  list.appendChild(dataBindEvent(time, isFree, event.title, event.slug, venue));
}

/**
 * Clones the `#cal-event-item` template and binds event data to its data-field slots.
 *
 * @param {string} time Display time string.
 * @param {boolean} isFree Whether the event is free.
 * @param {string} title Event title.
 * @param {string} slug Event slug, used to build the detail page URL.
 * @param {string} venue Venue name, or empty string if none.
 * @returns {DocumentFragment} The populated template clone.
 */
function dataBindEvent(time, isFree, title, slug, venue) {

  const template = document.getElementById('cal-event-item');
  const item = template.content.cloneNode(true);
  const eventUrlPrefix = template.dataset.eventUrlPrefix;

  item.querySelector('[data-field="time"]').textContent = time;

  const freePill = item.querySelector('[data-field="free"]');
  if (!isFree) {
    freePill.remove();
  }

  const eventLink = item.querySelector('[data-field="event-link"]');
  eventLink.textContent = title;
  eventLink.href = `${eventUrlPrefix}${slug}`;

  const venueSpan = item.querySelector('[data-field="venue"]');
  if (venue) {
    venueSpan.textContent = venue;
  }
  else {
    venueSpan.remove();
  }

  return item;

}

init();